import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { CloseCode, createClient } from 'graphql-ws'
import { constants } from '../../constants'
import SessionStorage from '../../util/sessionstore'

const session = new SessionStorage()

const getAuthToken = () => {
  const profile = session.getProfile()
  return profile?.token || ''
}

const getTokenExpiryTimeout = () => {
  const expiry = session.getExpiry()
  console.log(expiry, 'getTokenExpiryTimeout')
  if (expiry) {
    const token_expiry_time = expiry.getTime()
    const current_time = new Date().getTime()
    const remaining_time = Math.round(token_expiry_time - current_time)
    // console.log(remaining_time,"Remaining Time")
    return remaining_time > 0 ? remaining_time : session.setExpiry(true)
    // return Math.round(token_expiry_time - current_time);
  }
  return constants.TIMEOUT
}

function createRestartableClient(options) {
  let restartRequested = false
  let restart = () => {
    restartRequested = true
  }

  const client = createClient({
    ...options,
    on: {
      ...options.on,
      opened: (socket) => {
        // options.on?.opened?.(socket);

        restart = () => {
          if (socket.readyState === WebSocket.OPEN) {
            // if the socket is still open for the restart, do the restart
            socket.close(4205, 'Client Restart')
          } else {
            // otherwise the socket might've closed, indicate that you want
            // a restart on the next opened event
            restartRequested = true
          }
        }

        // just in case you were eager to restart
        if (restartRequested) {
          restartRequested = false
          restart()
        }
      },
    },
  })

  return {
    ...client,
    restart: () => restart(),
  }
}

let activeSocket,
  timedOut,
  tokenExpiryTimeout = null, // the socket close timeout due to token expiry
  shouldRefreshToken = false

const wsLink = new GraphQLWsLink(
  createRestartableClient({
    url: constants.WS_LINK,
    keepAlive: constants.KEEP_LIVE, // ping server every 10 seconds
    connectionParams: async () => {
      if (shouldRefreshToken) {
        shouldRefreshToken = false
        return { authToken: getAuthToken() }
      }

      return { authToken: '' }
    },
    lazy: false,
    retryAttempts: constants.SOCKET_RETRY_ATTEMPTS,
    // more or less copied directly from https://github.com/enisdenjo/graphql-ws#retry-strategy
    retryWait: async () => {
      // after the server becomes ready, wait for a  5s timeout
      // (avoid DDoSing) and try connecting again, but only in production
      await new Promise((resolve) => setTimeout(resolve, 5000)) //5sec delay
    },
    shouldRetry: (err) => {
      console.log(
        err?.code,
        ':shouldRetry => ',
        err?.code === CloseCode.Forbidden
      )
      return (shouldRefreshToken = true)
    },
    on: {
      closed: (event) => {
        console.log(event.code, 'Socket CLOSED')
        // if closed with the `4403: Forbidden` close event
        // the client or the server is communicating that the token
        // is no longer valid and should be therefore refreshed
        if (event.code === CloseCode.Forbidden) shouldRefreshToken = true
      },
      ping: (received) => {
        console.log('Socket ping', received)
        if (!received)
          // sent
          timedOut = setTimeout(() => {
            if (activeSocket.readyState === WebSocket.OPEN)
              activeSocket.close(4408, 'Request Timeout')
          }, 5000) // wait 5 seconds for the pong and then close the connection
      },
      pong: (received) => {
        console.log('Socket pong => ', received)
        if (received) {
          clearTimeout(timedOut) // pong is received, clear connection close timeout
        }
      },
      connected: (socket) => {
        activeSocket = socket // to be used at pings & pongs
        // get the access token expiry time and set a timer to close the socket
        // once the token expires... Since 'retryAttempts: Infinity' it will
        // try to reconnect again by getting a fresh token.

        // clear timeout on every connect for debouncing the expiry
        clearTimeout(tokenExpiryTimeout)

        // set a token expiry timeout for closing the socket
        // with an `4403: Forbidden` close event indicating
        // that the token expired. the `closed` event listner below
        // will set the token refresh flag to true

        tokenExpiryTimeout = setTimeout(() => {
          if (socket.readyState === WebSocket.OPEN)
            socket.close(CloseCode.Forbidden, 'Forbidden')
        }, getTokenExpiryTimeout())
      },
      connecting: () => console.log('Socket connecting'),
      error: () => console.log('Socket error'),
      message: () => console.log('Socket message'),
      opened: () => console.log('Socket opened'),
    },
  })
)

export default wsLink
